module.exports = __webpack_public_path__ + "static/media/ulip_hin.19ca4952.mp3";